import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b720941e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "self-checkin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "SELF CHECKIN", -1))
const _hoisted_3 = { id: "ticket" }
const _hoisted_4 = { class: "ticket-name" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "ticket-code row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "코드 ", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "ticket-ordered-dt row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "구매일", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = {
  key: 0,
  class: "ticket-canceled-dt row"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "취소일 ", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "ticket-expiry-date row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "만료일", -1))
const _hoisted_17 = { class: "value" }
const _hoisted_18 = {
  key: 1,
  class: "ticket-used-dt row"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "사용일", -1))
const _hoisted_20 = { class: "value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert" }, [
  /*#__PURE__*/_createTextVNode("시티투어 기사님 외에는 사용버튼을 '절대' 누르지마세요. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 사용처리 시 취소/환불 불가합니다.")
], -1))
const _hoisted_22 = {
  key: 2,
  class: "button used"
}
const _hoisted_23 = {
  key: 3,
  class: "button expiry"
}
const _hoisted_24 = {
  key: 4,
  class: "button expiry"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.ticket.name), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.ticket.code), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.ticket_ordered_dt), 1)
      ]),
      (_ctx.is_canceled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.ticket_canceled_dt), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.ticket_expiry_date), 1)
      ]),
      (_ctx.is_used)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.ticket_used_dt), 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_21,
      (_ctx.is_used)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, "사용함"))
        : (_ctx.is_canceled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, "취소됨"))
          : (_ctx.is_expiry)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, "만료됨"))
            : (!_ctx.is_used&&!_ctx.is_expiry)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 5,
                  class: "button no-used",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.use && _ctx.use(...args)))
                }, "사용"))
              : _createCommentVNode("", true)
    ])
  ]))
}